import { getAuth } from 'firebase/auth';
import React, { PureComponent, useContext, useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import logo from '../../img/kOnzy.gif';
export default function Loading (){
    const [count, setCount] = useState(3);
    
    const navigate=useNavigate();
       
        
        

    useEffect(() => {
       

     const interval =setInterval(()=>{
        setCount((currentCount) => --currentCount)
       
     },1000)
    
    count === 0&&toast.error(" you aren't logged in ") &&  setTimeout(()=>{
      navigate("/login") 
  },1000) 
    
     return()=> clearInterval(interval)
    }, [count])
    
    return (
    <>
      <Toaster toastOptions={{duration:1000}} />
      <div className='d-flex justify-content-center align-items-center vh-100'>
        <img src={logo} alt="Loading" style={{height:"50px"}} />
        </div></>
    )
  
}

